// extracted by mini-css-extract-plugin
export default {"icon":"ProductIcon_icon__TEZFd"};